import { render } from "./DropdownFilters.vue?vue&type=template&id=21a7c8d1&scoped=true&ts=true"
import script from "./DropdownFilters.vue?vue&type=script&lang=ts"
export * from "./DropdownFilters.vue?vue&type=script&lang=ts"

import "./DropdownFilters.vue?vue&type=style&index=0&id=21a7c8d1&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a7c8d1"]])

export default __exports__